function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React from "react";
import * as BaseButtonStyles from "./Button.style";

var BaseButton = _ref => {
  var { danger, className, children, renderLeftIcon, renderRightIcon } = _ref,
    props = _objectWithoutProperties(_ref, [
      "danger",
      "className",
      "children",
      "renderLeftIcon",
      "renderRightIcon"
    ]);

  return /*#__PURE__*/ React.createElement(
    BaseButtonStyles.StyledButton,
    _extends(
      {
        className: className,
        type: "submit"
      },
      props
    ),
    renderLeftIcon && renderLeftIcon(),
    children &&
      /*#__PURE__*/ React.createElement(BaseButtonStyles.StyledButtonText, null, children),
    renderRightIcon && renderRightIcon()
  );
};

export { BaseButtonStyles };
export default BaseButton;
